"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = [{
  label: 'AUSTRALIA',
  prefix: 'flagaus',
  value: 'AUS'
}, {
  label: 'UNITED STATES',
  prefix: 'flagus',
  value: 'US'
}, {
  label: 'SINGAPORE (USD)',
  prefix: 'flagsg',
  value: 'ASIA_US'
}, {
  label: 'SINGAPORE',
  prefix: 'flagsg',
  value: 'SG'
}, {
  label: 'UNITED KINGDOM',
  prefix: 'flaguk',
  value: 'UK'
}];
exports.default = _default;